import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { AuthLayout } from "../components/auth-layout";
import { Button } from "../components/ui/button";
import { Input, Label } from "../components/ui/input";
import { authClient } from "../lib/auth";

export const Route = createFileRoute("/forgot-password")({ component: ForgotPassword });

function ForgotPassword() {
  const [sent, setSent] = useState(false);
  return (
    <AuthLayout title="Reset password" description="We'll email you a link to set a new password.">
      {sent ? (
        <p className="text-sm">If an account exists for that address, the email is on its way.</p>
      ) : (
        <form
          className="flex flex-col gap-4"
          onSubmit={async (e) => {
            e.preventDefault();
            const email = String(new FormData(e.currentTarget).get("email"));
            await authClient.requestPasswordReset({
              email,
              redirectTo: `${window.location.origin}/reset-password`,
            });
            setSent(true);
          }}
        >
          <div className="flex flex-col gap-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" name="email" type="email" required />
          </div>
          <Button type="submit">Send link</Button>
        </form>
      )}
      <Link
        to="/login"
        className="mt-4 block text-center text-sm text-muted-foreground hover:underline"
      >
        Back to sign in
      </Link>
    </AuthLayout>
  );
}
